import { render } from "./tutorModify.vue?vue&type=template&id=b0fc87a0&scoped=true"
import script from "./tutorModify.vue?vue&type=script&lang=js"
export * from "./tutorModify.vue?vue&type=script&lang=js"

import "./tutorModify.vue?vue&type=style&index=0&id=b0fc87a0&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/Stage-integrated-sugang-admin-front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b0fc87a0"]])

export default __exports__